import { useToken } from "@gluestack-style/react";
import CreditCardIconHandler from "components/general/CreditCardIconHandler";
import { Box } from "components/ui/box";
import { Typography } from "components/ui/Typography";
import React from "react";
import { default as ReactSelect, StylesConfig } from "react-select";

interface Props {
	variant?: "outlined" | "primary" | "secondary";
}
export const Select = ({ variant, onChange, options, value, label, isMulti = false, isSearchable = false, isClearable = true, defaultValue, isCreditCard, placeholder }: SelectProps & Props) => {
	const resolvedPrimarylight = useToken("colors", "primarylight");
	const resolvedPrimary = useToken("colors", "primary");

	const colourStyles: StylesConfig = {
		menu(base, props) {
			return {
				...base,
				position: "absolute",
				zIndex: 9999, // Increased z-index
				marginTop: 4,
				width: "100%",
				backgroundColor: "#fff", // Add background
				boxShadow: "0 4px 12px rgba(0,0,0,0.15)", // Optional shadow
				borderRadius: 8,
			};
		},
		option(base, props) {
			const isSelected = props.isSelected;
			return {
				...base,
				fontFamily: "Calibri",
				fontWeight: 400,
				padding: 12,
				backgroundColor: isSelected ? resolvedPrimarylight : "transparent",
				color: isSelected ? "white" : "black",
				":hover": {
					backgroundColor: isSelected ? resolvedPrimarylight : "#F5F5F5",
					color: isSelected ? "white" : "black",
				},
			};
		},
		control(base, props) {
			return {
				...base,
				fontFamily: "Calibri",
				fontWeight: 400,
				paddingBlock: 6,
				borderRadius: 12,
				borderColor: "#B3B3B3",
			};
		},
	};
	const styledSelect: StylesConfig = {
		menu(base, props) {
			return {
				...base,
				position: "absolute",
				zIndex: 9999, // Increased z-index
				marginTop: 4,
				width: "100%",
				backgroundColor: "#fff", // Add background
				boxShadow: "0 4px 12px rgba(0,0,0,0.15)", // Optional shadow
			};
		},
		option(base, props) {
			const isSelected = props.isSelected;
			return {
				...base,
				fontFamily: "Calibri",
				fontWeight: 400,
				padding: 12,
				backgroundColor: isSelected ? resolvedPrimarylight : "transparent",
				color: isSelected ? "white" : "black",
				":hover": {
					backgroundColor: isSelected ? resolvedPrimarylight : "#F5F5F5",
					color: isSelected ? "white" : resolvedPrimarylight,
				},
			};
		},
		placeholder: (defaultStyles) => {
			return {
				...defaultStyles,
				color: resolvedPrimarylight,
			};
		},
		dropdownIndicator: (defaultStyles) => ({
			...defaultStyles,
			color: resolvedPrimarylight,
		}),
		control(base, props) {
			return {
				...base,
				fontFamily: "Calibri",
				fontWeight: 400,
				paddingBlock: 6,
				borderRadius: 12,
				borderColor: resolvedPrimarylight,
			};
		},
	};
	const formatOptionLabel = ({ label }: any) => {
		const regex = /(?<name>[A-Z]+) \*\d+ \((?<expiry>\d{1,2}\/\d{4})\)/;
		let cardType = label.match(regex)?.groups.name;

		return (
			<div style={{ display: "flex", alignItems: "center" }}>
				<CreditCardIconHandler isSmall type={cardType} />
				<span style={{ marginLeft: 8 }}>{label}</span>
			</div>
		);
	};

	return (
		<Box zIndex={999} position="relative">
			{label && (
				<Typography
					sx={{
						position: "absolute",
						top: -11,
						zIndex: 1,
						lineHeight: "1.5",
						left: 11,
						background: "#FAFAFA",
						paddingLeft: 6,
						fontSize: 13,
						fontWeight: 700,

						paddingRight: 6,
					}}
				>
					{label}:
				</Typography>
			)}
			{/* <ReactSelect defaultValue={[options[2], options[3]]} isMulti={isMulti} name="colors" options={options} className="basic-multi-select" classNamePrefix="select" /> */}
			<ReactSelect
				value={value}
				defaultValue={defaultValue}
				isMulti={isMulti}
				isSearchable={isSearchable}
				className="basic-multi-select"
				classNamePrefix="select"
				onChange={(value) => {
					// Handle both single and multi-select values
					if (isMulti) {
						onChange(value); // Pass the full array for multi-select
					} else {
						onChange(value ? value.value : null); // For single select, pass just the value
					}
				}}
				placeholder={placeholder}
				options={options}
				styles={variant === "outlined" ? styledSelect : colourStyles}
				formatOptionLabel={isCreditCard ? formatOptionLabel : undefined}
				isClearable={isClearable}
			/>
		</Box>
	);
};
